export default __webpack_public_path__ + "static/og-twitter-b7eb47b1f31eb32560ce23897f08935e.png";